// extracted by mini-css-extract-plugin
module.exports = {"successBlock":"Registration_successBlock__bud6O","homeButton":"Registration_homeButton__E_pzm","successTitle":"Registration_successTitle__u8ooW"};